<div [class]="environment.landingPageSidebar ? 'main-column' : 'full-column'">

	<div class="builder-loading" *ngIf="pageLoading && !pageError">
		Loading...
	</div>
	<div class="builder-loading" *ngIf="pageError">
		<span>
			Sorry, something went wrong loading this page. Please <span class="retry-link" (click)="loadPageData()">try again</span>.
		</span>
		
	</div>
	<div *ngIf="!pageLoading && !pageError" class="builder-main-content">
		<xng-breadcrumb separator=">">
			<ng-container *xngBreadcrumbItem="let breadcrumb">
				<ng-container>{{ breadcrumb | titlecase }}</ng-container>
			</ng-container>
		</xng-breadcrumb>
		<img
			*ngIf="!pageData.hide_banner && pageData.hero_banner"
			class="builder-hero-image"
			[class.large-only]="pageData.hero_banner_mobile && pageData.hero_banner_mobile.url"
			[src]="pageData.hero_banner.url"
			[alt]="pageData.hero_banner.custom_properties.alt_text"
			[height]="pageData.hero_banner.height"
			[width]="pageData.hero_banner.width"
		>
		<img
			*ngIf="!pageData.hide_banner && pageData.hero_banner_mobile"
			class="builder-hero-image small-only"
			[src]="pageData.hero_banner_mobile.url"
			[alt]="pageData.hero_banner_mobile.custom_properties?.alt_text"
			[height]="pageData.hero_banner_mobile.height"
			[width]="pageData.hero_banner_mobile.width"
		>
		<div
			*ngIf="pageData.tnc_txt"
			class="tnc-section builder-default-layout"
			[style.max-width]="(pageData.desktop_width ? pageData.desktop_width : '1110') + 'px'"
		>
			<div class="tnc-row">
				<div class="text-section" *ngIf="pageData.tnc_txt" cols="12" md="8">
					{{ pageData.tnc_txt }}
				</div>
				<div class="button-section" *ngIf="pageData.tnc_btn_txt" cols="12" md="4">
					<a class="button"
						[href]="pageData.tnc_btn_url"
						target="_blank"
						[style.background-color]="pageData.main_btn_color ? pageData.main_btn_color : 'initial'"
						[style.font-weight]="pageData.tnc_btn_weight ? pageData.tnc_btn_weight : '500'"
						[style.color]="pageData.tnc_txt_color ? pageData.tnc_txt_color : 'initial'"
						[class.block]="pageData.tnc_btn_size === 'blocked'"
						[class.small]="pageData.tnc_btn_size === 'small'"
						[class.large]="pageData.tnc_btn_size === 'large'"
						[class.medium]="pageData.tnc_btn_size === 'medium'"
						[class.x-large]="pageData.tnc_btn_size === 'extra_large'"
						[class.x-small]="pageData.tnc_btn_size === 'extra_small'"
					>
						{{ pageData.tnc_btn_txt }}
					</a>
				</div>
			</div>
		</div>
		<div
			*ngFor="let component of pageData.sections"
			class="builder-components"
		>
			<app-card-desktop
				*ngIf="component.type === 'card_desktop'"
				[data]="component"
			></app-card-desktop>
			<app-card-mobile
				*ngIf="component.type === 'card_mobile'"
				[data]="component"
			></app-card-mobile>
			<app-page-body
				*ngIf="component.type === 'page_body'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-body>
			<app-page-button
				*ngIf="component.type === 'page_button'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-button>
			<app-page-card
				*ngIf="component.type === 'page_card'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-card>
			<app-page-feature
				*ngIf="component.type === 'page_feature'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-feature>
			<app-page-gallery
				*ngIf="component.type === 'page_gallery'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-gallery>
			<app-page-heading
				*ngIf="component.type === 'page_heading'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-heading>
			<app-page-how-to
				*ngIf="component.type === 'page_how_to'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-how-to>
			<app-page-image-dropper
				*ngIf="component.type === 'page_image_dropper'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-image-dropper>
			<app-page-service
				*ngIf="component.type === 'page_service'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-service>
			<app-page-spacer
				*ngIf="component.type === 'page_spacer'"
				[data]="component"
				[desktopWidth]="pageData.desktop_width"
			></app-page-spacer>
		</div>

		<ng-container *ngIf="pageData.authors?.length">
			<div class="author-profile" *ngFor="let author of pageData.authors">
				<div class="author-image" *ngIf="author.thumbnail">
					<picture *ngIf="author.thumbnail?.dynamic_url">
						<source [srcset]="author.thumbnail.dynamic_url + '?w=200&fm=webp'" type="image/webp">
						<source [srcset]="author.thumbnail.dynamic_url + '?w=200'" type="image/jpeg">
						<img alt=""
							[src]="author.thumbnail.dynamic_url + '?w=200'" class="book-image" loading="lazy">
					</picture>
				</div>
				<div class="author-text">
					<a class="author-name" routerLink="/news/author/{{ author.slug }}">{{ author.first_name }} {{ author.last_name }}</a>
					<div class="author-bio" [innerHtml]="author.description"></div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div class="sidebar" *ngIf="environment.landingPageSidebar">
    <app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-upcoming-matches-list
        *ngIf="environment.availableSports.length > 0"
    ></app-upcoming-matches-list>
    <app-book-offers *ngIf="environment.optionalFeatures.includes('welcome-offers')"></app-book-offers>
    <app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
    <app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-display-ad type="sidebar-multi" *ngIf="environment.googleAdsConfig?.adSpaces?.['sidebar-multi'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>